export const DEFAULT_COUNTRY = "Deutschland"

export const DACH_COUNTRY_OPTIONS = [
  { name: "Deutschland", value: "Deutschland" },
  { name: "Österreich", value: "Österreich" },
  { name: "Schweiz", value: "Schweiz" },
]

const COUNTRY_ALIASES: Record<string, string> = {
  de: "Deutschland",
  deu: "Deutschland",
  deutschland: "Deutschland",
  germany: "Deutschland",
  at: "Österreich",
  aut: "Österreich",
  austria: "Österreich",
  oesterreich: "Österreich",
  österreich: "Österreich",
  ch: "Schweiz",
  che: "Schweiz",
  schweiz: "Schweiz",
  suisse: "Schweiz",
  svizzera: "Schweiz",
  switzerland: "Schweiz",
}

const clean = (value: unknown): string =>
  String(value ?? "")
    .replace(/\s+/g, " ")
    .trim()

export const normalizeCountryLabel = (
  value: string | null | undefined,
  fallback = DEFAULT_COUNTRY,
): string => {
  const cleaned = clean(value)

  if (!cleaned) return fallback

  return COUNTRY_ALIASES[cleaned.toLocaleLowerCase("de-DE")] ?? cleaned
}

export const normalizeDachCountrySelection = (value: string | null | undefined): string => {
  const normalized = normalizeCountryLabel(value)

  return DACH_COUNTRY_OPTIONS.some((entry) => entry.value === normalized)
    ? normalized
    : DEFAULT_COUNTRY
}

export type AddressLike = {
  street?: string | null
  house_number?: string | null
  zip?: string | null
  city?: string | null
  country?: string | null
  address_extra?: string | null
}

export const formatAddressLines = (
  address?: AddressLike | null,
  unitLabel?: string | null,
): string[] => {
  if (!address) return ["Unbekannte Liegenschaft"]

  const streetLine = [address.street, address.house_number].map(clean).filter(Boolean).join(" ")
  const addressExtraLine = clean(address.address_extra)
  const cityLine = [address.zip, address.city].map(clean).filter(Boolean).join(" ")
  const rawCountry = clean(address.country)
  const countryLine =
    streetLine || cityLine || rawCountry ? normalizeCountryLabel(address.country) : ""

  return [
    streetLine,
    addressExtraLine,
    cityLine,
    countryLine,
    unitLabel ? clean(unitLabel) : "",
  ].filter(Boolean)
}

export const formatAddressInline = (
  address?: AddressLike | null,
  unitLabel?: string | null,
): string => formatAddressLines(address, unitLabel).join(", ")
